import axios from 'axios'
import interceptors from './interceptors'

axios.defaults.timeout = 15000;
axios.defaults.withCredentials = true;

//添加拦截器
interceptors();

const DEFAULT_CONFIG = {
    dataType: 'json',
    method: 'get',
    baseURL: '/apis'
};

const requestType = {
    json: {
        transformRequest: function (data) {
            return data
        },
        config: {}
    },
    form: {
        transformRequest: function (data) {
            let kyArray = []
            for (let key in data) {
                kyArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
            }
            return kyArray.join('&')
        },
        config: {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        }
    },
    file: {
        transformRequest: function (data) {
            let formData = new FormData();
            for (let key in data) {
                formData.append(key, data[key])
            }
            return formData
        },
        config: {
            'Content-Type':'multipart/form-data'
        }
    }
};

const covertParams = {
    get: function (config, params) {
        config.params = params;
        return config
    },
    post: function (config, params, requestType) {
        config.data = requestType.transformRequest(params);
        config = Object.assign(config, requestType.config);
        return config
    },
    put: function (config, params, requestType) {
        config.data = requestType.transformRequest(params);
        config = Object.assign(config, requestType.config);
        return config
    },
    delete: function (config, params) {
        config.params = params
        return config
    }
}

function compilePath(url, params) {
    let paths = url.split('/');
    let replaceKeys = [];
    paths = paths.map(item => {
        if(item.indexOf(':') === 0) {
            const key = item.substring(1, item.length);
            replaceKeys.push(key);
            return encodeURIComponent(params[key])
        }
        return item
    });
    replaceKeys.forEach(item => {
        delete params[item]
    });
    return paths.join('/')
}

function Http(config) {
    this.config = Object.assign( {}, DEFAULT_CONFIG, config);
    this.requestType = requestType[this.config.dataType];
    delete this.config.dataType
}

Http.prototype = {
    do: function (params, options) {
        if (params === null || params === undefined){
            params = {}
        } else {
            params = Object.assign({}, params)
        }

        if (options) {
            if (options.progress && typeof options.progress === 'function'){ this.config.onUploadProgress =  options.progress}
            this.ignoreError = options.ignoreError
        }

        this.config.url = compilePath(this.config.url, params);
        return axios
            .request(covertParams[this.config.method](this.config, params, this.requestType))
            .then(this.result.bind(this))
            .catch(this.error.bind(this))
    },
    result: function (res) {
        if (res && res.data) {
            if (res.data.status === 0) {
                return res.data;
            } else {
                throw new Error(res.data.msg);
            }
        } else {
            throw new Error('网络异常')
        }
    },
    error: function (error) {
        if (window.app && !this.ignoreError) {
            window.app.$toast.fail(error.message ? error.message : '网络错误')
        }
        throw error
    }
}

function mergeRequest() {
    const request= {}
    const requestModules = require.context('./modules', true, /[A-Za-z0-9-_,\s]+\.js$/i);
    requestModules.keys().forEach(key => {
        const module = requestModules(key);
        for(let mKey in module) {
            const config = module[mKey];
            request[mKey] = function (params, options) {
                return new Http(config).do(params, options)
            }
        }
    })
    return request
}

export default mergeRequest()
